import React from 'react';
import './header.css';

const Header = (props) => (
	<header>
		<h1>dairy app</h1>
		<p>Comment with no sense</p>
	</header>
)

export default Header